import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { cambiarPassword, login } from '../services/authService';
import { useAuth } from '../context/AuthContext';

const IconoOjo = ({ tachado }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
        {tachado && <line x1="3" y1="3" x2="21" y2="21" />}
    </svg>
);

// Campo de contraseña con ojo para verla sin ocultar.
function CampoPassword({ id, value, onChange, ...resto }) {
    const [visible, setVisible] = useState(false);
    return (
        <div className="campo-password">
            <input {...resto} type={visible ? 'text' : 'password'} id={id} value={value} onChange={onChange} required />
            <button type="button" className="btn-ojo" aria-pressed={visible}
                aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                onClick={() => setVisible((v) => !v)}>
                <IconoOjo tachado={visible} />
            </button>
        </div>
    );
}

function Login() {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [enviando, setEnviando] = useState(false);
    // Rol del usuario que entró con contraseña temporal: activa el paso de cambio.
    const [rolPendiente, setRolPendiente] = useState(null);
    const [nueva, setNueva] = useState('');
    const [repetida, setRepetida] = useState('');
    const navigate = useNavigate();
    const { recargar } = useAuth();

    const aterrizar = async (rol) => {
        await recargar();
        // Un jugador aterriza en su zona personal (fuera de /dashboard); ADMIN/COMITE en el menú de gestión.
        navigate(rol === 'JUGADOR' ? '/mi-area-personal' : '/dashboard');
    };

    const handleCambio = async (event) => {
        event.preventDefault();
        setError(null);
        if (nueva.length < 8) return setError('La contraseña nueva debe tener al menos 8 caracteres.');
        if (nueva !== repetida) return setError('Las contraseñas no coinciden.');
        if (nueva === password) return setError('La contraseña nueva debe ser distinta de la temporal.');
        setEnviando(true);
        try {
            await cambiarPassword({ passwordActual: password, passwordNueva: nueva });
            await aterrizar(rolPendiente);
        } catch (err) {
            setError(err.message || 'No se pudo cambiar la contraseña.');
        } finally {
            setEnviando(false);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setEnviando(true);
        try {
            const { datos } = await login({ usuario, password });
            if (datos.debeCambiarPassword) {
                setRolPendiente(datos.rol);
                return;
            }
            await aterrizar(datos.rol);
        } catch (err) {
            setError(err.codigo === 'CUENTA_BLOQUEADA'
                ? 'Demasiados intentos fallidos. Inténtalo de nuevo más tarde.'
                : 'Usuario o contraseña incorrectos.');
        } finally {
            setEnviando(false);
        }
    };

    if (rolPendiente) {
        return (
            <div className="login-page">
            <div className="login-container">
                <h2>Cambia tu contraseña</h2>
                <p>Has entrado con una contraseña temporal. Elige una propia para continuar.</p>
                <form onSubmit={handleCambio}>
                    {error && <p className="msg-error" role="alert">{error}</p>}
                    <div>
                        <label htmlFor="password-nueva">Contraseña nueva:</label>
                        <CampoPassword id="password-nueva" value={nueva} autoComplete="new-password"
                            minLength={8} onChange={(e) => setNueva(e.target.value)} />
                    </div>
                    <div>
                        <label htmlFor="password-repetida">Repite la contraseña:</label>
                        <CampoPassword id="password-repetida" value={repetida} autoComplete="new-password"
                            onChange={(e) => setRepetida(e.target.value)} />
                    </div>
                    <button type="submit" disabled={enviando}>
                        {enviando ? 'Guardando...' : 'Guardar y entrar'}
                    </button>
                </form>
            </div>
            </div>
        );
    }

    return (
        <div className="login-page">
        <div className="login-container">
            <h2>Iniciar sesión</h2>
            <form onSubmit={handleSubmit}>
                {error && <p className="msg-error">{error}</p>}
                <div>
                    <label htmlFor="usuario">Usuario:</label>
                    <input
                        type="text"
                        id="usuario"
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                        autoComplete="username"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="password">Contraseña:</label>
                    <CampoPassword id="password" value={password} autoComplete="current-password"
                        onChange={(e) => setPassword(e.target.value)} />
                </div>
                <button type="submit" disabled={enviando}>
                    {enviando ? 'Entrando...' : 'Iniciar sesión'}
                </button>
            </form>
        </div>
        </div>
    );
}

export default Login;
